/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ReceivableMessage/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ReceivableMessage({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/AutoApplyToggle/ReceivableMessage"
  
}) {
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let constantData = 'Invoice #'
let postPaymentInfoReceivableHumanReadableIdValueData = fromData.useDataValue({ viewPath,
context: 'post_payment_info',
path: 'receivable.human_readable_id',
})
let aggregateData = fromAggregate.joinNoSpace(constantData, postPaymentInfoReceivableHumanReadableIdValueData)
  return (<React.Fragment
>
<div
  data-testid="ReceivableMessage.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="light"
 color={dtColorsNeutral900}
 text="This payment will be applied to"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 weight="medium"
 data="'Invoice #'"
 data="post_payment_info.receivable.human_readable_id"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}